<template>
    <div class="header flex_box">
        <div class="left flex_box">
            <img class="logo" src="../assets/images/logo.png" alt="AnyMP4 Logo">
            <a href="/watermark-remover-online/"><img src="../assets/images/logo.png" alt="Icon">{{$t("FreeWatermarkRemover")}}</a>
            <i></i>
            <label for="upload">
                <span class="upload_btn">{{$t("Upload")}}</span>
            </label>
        </div>
        <input type="file" name="upload" id="upload" accept=".jpg, .jpeg, .png, .bmp">
        <div class="right flex_box">
            <span class="history">
                <i></i>
                <span>{{$t("History")}}</span>
            </span>
            <span class="upgrad">
                <img src="../assets/images/upgrade-s.svg" alt="">
                <span>{{$t("Upgrade")}}</span>
            </span>
            <span class="login MemberLogin">
                <img src="../assets/images/user.svg" alt="User">
                <span>{{$t("Login")}}</span>
                <div class="photo_rights">
                    <p class="info" v-html="this.$t('photo_rights_info')"></p>
                    <span class="btn">{{$t("Upgrade")}}</span>
                </div>
                <div class="photo_rights_load">
                    <img class="load" src="../assets/images/load.svg" alt="Load" />
                    <p>{{$t("Loading")}}</p>
                </div>
            </span>
            <i class="photo_toggle"></i>
        </div>
        <history/>
        <div class="photo_toggle_box">
            <p><i></i>{{$t("Usinghelp")}}</p>
            <div class="flex_box">
            <p><i></i>{{$t("Enhancer")}}</p>
            <span><i></i></span>
            </div>
        </div>
        <div class="photo_guide_box flex_box">
            <dl>
                <dt>{{$t("Guide")}}</dt>
                <dd class="flex_box">
                <p><span>{{$t("Brush1")}}</span> {{$t("Brush_info")}}</p>
                </dd>
                <dd class="flex_box">
                <p><span>{{$t("Lasso1")}}</span> {{$t("Lasso_info")}}</p>
                </dd>
                <dd class="flex_box pc">
                <p><span>{{$t("Polygonal1")}}</span> {{$t("Polygonal_info")}}</p>
                </dd>
                <dd class="flex_box">
                <p><span>{{$t("Eraser1")}}</span> {{$t("Eraser_info")}}</p>
                </dd>
                <dd class="flex_box">
                <p><span>{{$t("Click")}}</span> {{$t("the")}} <span>{{$t("Remove")}}</span> {{$t("click_info")}}</p>
                </dd>
            </dl>
            <img class="pc" src="../assets/images/guide.gif" alt="Guide">
            <img class="mobile" src="../assets/images/guide-mobile.gif" alt="Guide">
        </div>
        <div class="mobile_box flex_box">
            <label for="upload">{{$t("Upload")}}</label>
            <div class="flex_box">
                <i class="history"></i>
                <i class="crop_tab"></i>
                <span class="down">{{$t("Download")}}</span>
                <span class="crop_down">{{$t("Download")}}</span>
            </div>
        </div>
    </div>
</template>

<script>
import history from "@/components/history"
import Japp from "@/assets/js/app"
export default {
    components:{
        history,
    },
    mounted(){
        // 打开购买
        $('.header .right>.upgrad').click(function(){
            $('.maskRights').show();
            $('.maskRightsBuyBox').show().siblings().hide();
        });
        $('.photo_rights .btn').click(function(){
            $('.header .right>.upgrad').click()
        })
        $('.header .right>.login').click(function(e){
            $('.photo_toggle_box').hide();
            $('.photoHistory_box').removeClass('active');
            $('.photo_rights').hide()
            if(user){
                e.stopPropagation();
                $('.header .login ul').show()
            }
        });
        // 查看权益
        $('.header .right>.login').click(function(e){
            $('.photoHistory_box').removeClass('active')
            $('.photo_toggle_box').hide();
            if(user){
                e.stopPropagation();
                $('.photo_rights_load').show();
                $('.photo_rights').hide();
                $.post(
                    post_url+'benefit/status',
                    {
                        e_id:murmur,
                        t_id:user.t_id,
                        token:user.token,
                        product_id:Japp.product_id
                    },
                    function(data){
                        error_fn(data.error);
                        switch(data.error){
                            case 0:
                                $('.photo_rights_load').hide();
                                app.subscriptions=data.subscriptions;
                                // 循环查询权益操作
                                var total=0;
                                var use=0;
                                console.log(app.subscriptions);
                                for(var i=0;i<app.subscriptions.length;i++){
                                    total+=app.subscriptions[i].benefits[3].quota*1
                                    use+=app.subscriptions[i].benefits[3].usage*1
                                }
                                $('.photo_rights').show();
                                $('.photo_rights .num').html(total-use);
                                break;
                            case 26801:
                                error(i18n[lang].error_26801);
                                $('.photo_rights_load').hide();
                                break;
                            case 26802:
                                error(i18n[lang].error_26802);
                                $('.photo_rights_load').hide();
                                break;
                            case 26803:
                                error(i18n[lang].error_26803);
                                $('.photo_rights_load').hide();
                                break;
                            case 26804:
                                error(i18n[lang].error_26804);
                                $('.photo_rights_load').hide();
                                break;
                        }
                    }
                ).fail(function(){
                    overtime(26899);
                    $('.photo_rights_load').hide();
                })
            return false;
            }
        });
        $('.photo_rights_load').click(function(e){
            e.stopPropagation()
        })
        $('.photo_rights').click(function(e){
            e.stopPropagation()
        })
        // 帮助
        $('.photo_toggle').click(function(e){
            e.stopPropagation();
            $('.photo_toggle_box').toggle();
            $('.photoHistory_box').removeClass('active');
            $('.photo_rights').hide()
            $('.header .login ul').hide();
        });
        $('.photo_toggle_box').click(function(e){
            e.stopPropagation();
        })
        $('.photo_toggle_box>p').click(function(e){
            $('.photo_guide_box').addClass('active');
            if($(window).width()>980){
                if($('.function_desk').offset().top>$('.photo_guide_box').outerHeight(true)+26){
                    $('.photo_guide_box').css({
                        left:$('.function_desk').offset().left,
                        bottom:$(window).height()-$('.function_desk').offset().top+26,
                        top:"unset"
                    })
                }else{
                    $('.photo_guide_box').css({
                        left:$('.function_desk').offset().left,
                        top:$('.function_desk').offset().top+$('.function_desk').outerHeight(true)+26,
                        bottom:"unset"
                    })
                }
            }
        });
        // 是否无损压缩
        $('.photo_toggle_box>div span').click(function(){
            var that=$(this);
            if(that.attr('class')=='no'){
                app.original=0;
                that.removeClass('no')
                return false;
            }
            that.addClass('load');
            var data;
            if(user){
                data={
                    e_id:murmur,
                    t_id:user.t_id,
                    token:user.token,
                    product_id:Japp.product_id
                }
            }else{
                data={
                    e_id:murmur,
                    product_id:Japp.product_id
                }
            }
            $.post(
                post_url+'benefit/status',
                data,
                function(data){
                    that.removeClass('load');
                    console.log(data);
                    error_fn(data.error);
                    switch(data.error){
                        case 0:
                            if(data.subscriptions[0].benefits[4].quota*1<1){
                                $('.maskRights').show();
                                $('.maskRightsBox').show().siblings().hide();
                                $('.maskRightsBox .tip').html(i18nWaterMark.global.t('rights_original'));
                                $('.maskRightsBox .tip_btn .upgrade_btn').show().siblings().hide()
                                if(!app.first){
                                    // app.manage('trigger_rights_first','benefits');
                                }else{
                                    // app.manage('trigger_rights','benefits');
                                }
                            }else{
                                that.addClass('no');
                                app.original=1;
                            }
                            console.log(app.original);
                            break;
                        case 26801:
                            error(i18n[lang].error_26801);
                            break;
                        case 26802:
                            error(i18n[lang].error_26802);
                            break;
                        case 26803:
                            error(i18n[lang].error_26803);
                            break;
                        case 26804:
                            error(i18n[lang].error_26804);
                            break;
                    }
                }
            ).fail(function(){
                that.removeClass('load');
                overtime(26899);
            })
        });
    }
}
</script>

<style scoped>
    .header{
        background: #fff;
        box-shadow: 0px 2px 12px 0px rgba(166, 166, 166, 0.3);
        height: 56px;
        padding-left: 25px;
        padding-right: 25px;
        box-sizing: border-box;
        align-items: center;
        position: fixed;
        top: 0px;
        left: 0px;
        width: 100%;
        z-index: 1;
    }
    .header .left{
        align-items: center;
    }
    .header .left .logo{
        display: inline-block;
        margin-right: 10px;
    }
    .header .left a{
        font-size: 24px;
        color: #1e1e1e; 
        line-height: 32px;
    }
    .header .left>a img{
        display: none;
    }
    .header .left i{
        width: 0px;
        height: 30px;
        border-left: 1px dashed #D5D5D5;
        margin: 0 20px;
        display: none;
    }
    .header .left label{
        display: none;
    }
    .header .right>span{
        display: inline-block;
        margin-right: 20px;
        color: #333;
        cursor: pointer;
    }
    .header .right span *{
        vertical-align: middle;
    }
    .header .right span img,.header .right span i{
        width: 24px;
        height: 24px;
        display: inline-block;
        margin-right: 8px;
    }
    .header .right{
        align-items: center;
        justify-content: flex-start;
    }
    .header .right .history i{
        background: url(../assets/images/history.png);
    }
    .header .right .login img{
        border-radius: 50%;
    }
    .header .right .guide{
        width: 24px;
        height: 24px;
        margin-right: 20px;
        background: url(../assets/images/guide.png);
    }
    .header .right .close{
        width: 20px;
        height: 20px;
        background: url(../assets/images/close.png);
    }
    .header .upload_btn{
        min-width: 110px;
        line-height: 36px;
        height: 36px;
        background: #21a1f2;
        border-radius: 8px;
        font-size: 16px;
        color: #fff;
        text-align: center;
        padding-left: 10px;
        padding-right: 10px;
        box-sizing: border-box;
        display: block;
        cursor: pointer;
    }
    .header .upload_btn:hover{
        background: #33c3f3;
    }
    .header #upload{
        display: none;
    }
    .photo_rights_load,.photo_rights{display: none;width: 330px;background: #FFFFFF;box-shadow: 0px 6px 13px -4px rgba(0, 0, 0, 0.5);border-radius: 9px;position: absolute;top: 70px;right: 60px;z-index: 101;padding: 0px 10px 0px 30px;box-sizing: border-box;cursor: auto;}
    .photo_rights_load,.photo_rights{padding:0 0 30px;}
    .header .photo_rights_load img.load{margin: 30px auto 20px;display: block;-webkit-animation: rotate 1.5s infinite linear;-moz-animation: rotate 1.5s infinite linear;-o-animation: rotate 1.5s infinite linear;animation: rotate 1.5s infinite linear;width: 60px;height: 60px;}
    .photo_rights_load p{text-align: center;font-size: 16px;color: #333;}
    /* photo_rights */
    .photo_rights{padding: 20px;}
    .photo_rights p.info{font-size: 18px;color: #333;line-height: 22px;}
    ::v-deep .photo_rights p.info span,.photo_rights p.info .num{color: #22A1F1;font-weight: bold;}
    ::v-deep .photo_rights p.info span i{width:auto;height: auto;margin: 0;line-height: auto;}
    ::v-deep .photo_rights p.info .num{font-style: normal;}
    ::v-deep .photo_rights p.info a{color: #22A1F1;text-decoration: underline;}
    .photo_rights .btn{width: 244px;height: 46px;line-height: 46px;font-size: 20px;font-weight: 600;color: #fff;background: #21a1f2;border-radius: 26px;display: block;margin: auto;text-align: center;margin-top: 20px;cursor: pointer;font-weight: normal;}
    .photo_rights .btn:hover{text-decoration: none;background: #33c3f3;color: #fff;}
    @media screen and (max-width:630px){
        .photo_rights_load{width: auto !important;padding-left: 10px;}
        .photo_rights_load{width: 240px !important;}
    }
    .photo_toggle{
        cursor: pointer;
        background: url(../assets/images/toggle.svg) no-repeat;
        width: 20px;
        height: 17px;
    }
    .photo_toggle_box{
        position: absolute;
        max-width: 410px;
        width: 96%;
        box-shadow: 0px 2px 13px -4px rgba(0, 0, 0, 0.5);
        border-radius: 10px;
        background: #fff;
        overflow: hidden;
        font-size: 16px;
        color: #333;
        line-height: 20px;
        right: 46px;
        top: 70px;
        display: none;
        z-index: 101;
        padding-left: 12px;
        padding-right: 12px;
        box-sizing: border-box;
    }
    .photo_toggle_box>p{
        padding-top: 14px;
        padding-bottom: 14px;
        cursor: pointer;
        border-bottom: 1px solid #EBEBEB;
        padding-left: 34px;
        position: relative;
    }
    .photo_toggle_box>p i{
        width: 24px;
        height: 24px;
        background: url(../assets/images/help.svg);
        position: absolute;
        left: 0px;
        top: 12px;
    }
    .photo_toggle_box>div{
        padding-top: 10px;
        padding-bottom: 12px;
        justify-content: flex-start;
    }
    .photo_toggle_box>div p{
        width: calc(100% - 100px);
        position: relative;
        padding-left: 34px;
    }
    .photo_toggle_box>div p i{
        width: 24px;
        height: 24px;
        background: url(../assets/images/enhancer.svg);
        position: absolute;
        left: 0px;
        top: 0px;
    }
    .photo_toggle_box>div span{
        width: 40px;
        height: 20px;
        box-sizing: border-box;
        border-radius: 10px;
        margin-top: 12px;
        padding: 2px;
        cursor: pointer;
        text-align: left;
        background: #B6B6B6;
        position: relative;
    }
    .photo_toggle_box>div span.no{
        text-align: right;
        background: #22A1F1;
    }
    .photo_toggle_box>div span i{
        width: 16px;
        height: 16px;
        background: #fff;
        border-radius: 50%;
    }
    .photo_toggle_box>div span::after{clear: both;content: "";position: absolute;top: 1px; right: -22px;width: 18px;height: 18px;background: url(../assets/images/load.svg) no-repeat center center/cover;-webkit-animation: rotate 1.5s infinite linear;-moz-animation: rotate 1.5s infinite linear;-o-animation: rotate 1.5s infinite linear;animation: rotate 1.5s infinite linear;opacity: 0;}
    .photo_toggle_box>div span.load::after{opacity: 1;}
    .photo_toggle:hover{
        background: url(../assets/images/toggle-h.svg);
    }
    .photo_toggle:active{
        background: url(../assets/images/toggle-a.svg);
    }
    .photo_guide_box{width:471px;min-height: 311px;padding-bottom: 10px;text-align:left;background:#fff;box-shadow:0 0 10px rgba(18, 18, 18, .18);border-radius:5px;position:fixed;left: 24px;bottom:110px;z-index:11;box-sizing: border-box;background: url(../assets/images/bg.jpg);box-shadow: 0px 3px 11px 0px rgba(0, 0, 0, 0.19);border-radius: 14px;overflow: hidden;display: none;}
    .photo_guide_box img{height: 188px;}
    .photo_guide_box .mobile{display: none;}
    .photo_guide_box.active{display:-webkit-box;display: -webkit-flex;display: flex;z-index: 101;}
    .photo_guide_box dl{max-width: 276px;width: 100%;margin-top: 10px;margin-left: 17px;}
    .photo_guide_box dl dt{font-size: 20px;color: #333;margin-bottom: 10px;}
    .photo_guide_box dl dd{-webkit-align-items: center;align-items: center;font-size: 14px;line-height: 24px;color: #333;}
    .photo_guide_box dl dd span{display: inline-block;color: #333;padding: 0;}
    
    /* 点击头像的下拉框 */
    /* .header .login ul li span{padding:0px;}
    .header .login ul li div,.header .login>div{width: 32px;height: 32px;border-radius: 50%;overflow: hidden;display: inline-block;border: 1px solid transparent;}
    .header .login ul li div img,.header .login>div img{width: 100%;height: 100%;object-fit: cover;display: block;margin: 0px;}
    .header .login ul li div.active,.header .login>div.active{border: 1px solid #e9b1ff;}
    .header .login ul li div{vertical-align: -2px;margin-right: 6px;margin-left: 0px;}
    .header .login ul li:first-child{padding-bottom: 6px;-webkit-align-items: center;align-items: center;display: flex !important;}
    .header .login ul li:first-child>p{font-size: 14px;color: #222;line-height: 24px;width: 174ox;display: inline-block;line-height: 20px;margin: 0px;}
    .header .login ul li:first-child>p *{white-space: nowrap;overflow: hidden;text-overflow: ellipsis;}
    .header .login ul li:first-child>p>span{display: block;}
    .header .login ul li:first-child>p .verification{font-size: 14px;color: #3E6AF9;text-decoration: underline;line-height: 14px;cursor: pointer;}
    .header .login ul{display: none;width: 240px;background: #FFFFFF;border: 1px solid #E4E4E4;border-radius: 8px;padding: 12px;box-sizing: border-box;position: absolute !important;right: 28px;top: 50px;z-index: 1;}
    .header .login ul li:first-child>p .verification img{vertical-align: -2px;margin-left: 2px;width: 14px;height: 14px;-webkit-animation: rotate 1.5s infinite linear;-moz-animation: rotate 1.5s infinite linear;-o-animation: rotate 1.5s infinite linear;animation: rotate 1.5s infinite linear;opacity: 0;}
    .header .login ul li:first-child>p .verification.unbind img{opacity: 1;}
    .header .login ul::before{clear:both;content:"";width:0px;height:0px;border:8px solid #fff;border-color:transparent transparent #e6e6e6;position:absolute;right:48px;top:-16px;}
    .header .login ul::after{clear:both;content:"";width:0px;height:0px;border:8px solid #fff;border-color:transparent transparent #fff;position:absolute;right:48px;top:-14px;}
    .header .login ul li{border-top: 1px solid #e6e6e6;padding-top: 12px;padding-bottom: 12px;box-sizing: border-box;margin-right: 0px !important;display: block !important;text-align: left;line-height: 24px;float: none;}
    .header .login ul li:first-child{padding-top: 0px;border-top: none;}
    .header .login ul li:last-child{padding-bottom: 0px;cursor: pointer;display: -webkit-box;display: -webkit-flex;display: flex !important;}
    .header .login ul li a,
    .login ul li,
    .login ul li:last-child>span{font-size: 16px;color: #3E6AF9;line-height: 24px;padding: 0px;float: none;display: -webkit-box;display: -webkit-flex;display: flex;}
    .header .login ul li a img,.header .login ul li img{margin-left: 12px;margin-right: 9px;display: inline-block;}
    .header .login ul li a,.header .login ul li{-webkit-justify-content: flex-start !important;justify-content: flex-start !important;-webkit-align-items: center;align-items: center;}
    .header .login ul li a span{width: 168px;}
    .header .login ul li a:hover{text-decoration: none;} */


    .header .mobile_box{display: none;}
    @media screen and (max-width:980px){
        .header{
            height: auto;
            padding-top: 12px;
        }
        .header .left .logo{
            display: none;
        }
        .header .left i{
            display: none !important;
        }
        .header .left label{
            display: none !important;
        }
        .header .left>a{
            display: flex;
            align-items: center;
            font-size: 14px;
        }
        .header .left>a img{
            display: inline-block;
            width: 80px;
            margin-right: 8px;
        }
        .header .right>span{
            margin-right: 0px;
        }
        .header>label{
            display: none;
        }
        .header>.right>.history{
            display: none !important;
        }
        .header .mobile_box{
            border-top: 1px solid #A6A6A6;
            width: 100%;
            padding-top: 10px;
            padding-bottom: 10px;
            position: relative;
            display: flex;
            margin-top: 10px;
        }
        .header .mobile_box::before,.header .mobile_box::after{
            clear: both;
            content: "";
            width: 25px;
            height: 1px;
            background: #A6A6A6;
            position: absolute;
        }
        .header .mobile_box::before{
            left: -25px;
            top: -1px;
        }
        .header .mobile_box::after{
            right: -25px;
            top: -1px;
        }
        .header .mobile_box>label{
            min-width: 76px;
            height: 28px;
            line-height: 26px;
            border: 1px solid #21a1f2;
            background: #d7f0ff;
            border-radius: 4px 4px 4px 4px;
            font-size: 14px;
            text-align: center;
            color: #21a1f2;
            box-sizing: border-box;
            padding-left: 10px;
            padding-right: 10px;
            visibility: hidden;
        }
        .header .mobile_box div{
            align-items: center;
        }
        .header .mobile_box .history{
            display: inline-block;
            width: 24px;
            height: 24px;
            background: url(../assets/images/history-mobile.svg);
            margin-right: 8px;
        }
        .header .mobile_box .crop_tab{
            width: 24px;
            height: 24px;
            background: url(../assets/images/crop-mobile.svg);
            margin-right: 12px;
            display: none;
        }
        .header .mobile_box .crop_tab.active{
            background: url(../assets/images/crop-mobile-h.svg);
        }
        .header .mobile_box .crop_tab.show{
            display: inline-block;
        }
        .header .mobile_box .down,.header .mobile_box .crop_down{
            min-width: 84px;
            height: 28px;
            line-height: 28px;
            border-radius: 4px 4px 4px 4px;
            font-size: 14px;
            text-align: center;
            color: #fff;
            background: #21a1f2;
            display: inline-block;
            box-sizing: border-box;
            padding-left: 10px;
            padding-right: 10px;
            display: none;
        }
        .header .mobile_box .down.show{
            display: block;
        }
        .header .mobile_box .crop_down{
            display: none;
        }
        .photo_toggle_box{
            right: unset;
            left: 50%;
            transform: translateX(-50%);
        }
        .header .login ul{
            right: 28px;
        }
        .photo_guide_box{
            left: 50% !important;
            transform: translateX(-50%) !important;
            bottom: 110px !important;
        }
        .photo_guide_box dl{
            width: 238px;
        }
        .photo_guide_box .pc{
            display: none;
        }
        .photo_guide_box .mobile{
            display: block;
        }
        .header .right>.login>span,.header .right>.upgrad>span{
            display: none !important;
        }
        .photo_rights_load,.photo_rights{
            right: unset;
            left: 50%;
            transform: translateX(-50%);
        }
    }
    @media screen and (max-width:470px){
        .photo_guide_box{
            zoom: .7;
        }
    }
    @media screen and (max-width:320px){
        .photo_guide_box{
            zoom: .65;
        }
    }
</style>